module.exports = __webpack_public_path__ + "img/used-icon.ce91ce03.png";